var _defs, _circle, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmptyReadinessMonitors = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Readiness_monitors_4",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaeaf3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9399b5"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7056",
    "data-name": "Ellipse 7056",
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#eaeaf3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35322",
    "data-name": "Group 35322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35316",
    "data-name": "Group 35316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35313",
    "data-name": "Group 35313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63290",
    "data-name": "Path 63290",
    d: "M43.229,25h63.542a6.11,6.11,0,0,1,6.11,6.11v87.982a6.11,6.11,0,0,1-6.11,6.11H43.229a6.11,6.11,0,0,1-6.11-6.11V31.11A6.11,6.11,0,0,1,43.229,25Z",
    transform: "translate(150 150.201) rotate(180)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35314",
    "data-name": "Group 35314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63291",
    "data-name": "Path 63291",
    d: "M107.993,120.515H42.007a.2.2,0,0,1-.2-.2V29.888a.2.2,0,0,1,.2-.2h65.986a.2.2,0,0,1,.2.2v90.425A.2.2,0,0,1,107.993,120.515Zm-65.784-.4h65.582V30.09H42.209Z",
    fill: "#eaeaf3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35315",
    "data-name": "Group 35315"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18270",
    "data-name": "Rectangle 18270",
    width: 54.988,
    height: 2.444,
    transform: "translate(46.74 54.327)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18271",
    "data-name": "Rectangle 18271",
    width: 54.988,
    height: 2.444,
    transform: "translate(46.74 61.659)",
    fill: "#eaeaf3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18272",
    "data-name": "Rectangle 18272",
    width: 54.988,
    height: 2.444,
    transform: "translate(47.506 104.35)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18273",
    "data-name": "Rectangle 18273",
    width: 54.988,
    height: 2.444,
    transform: "translate(47.506 111.682)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18274",
    "data-name": "Rectangle 18274",
    width: 29.553,
    height: 2.444,
    transform: "translate(60.224 97.019)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63292",
    "data-name": "Path 63292",
    d: "M86.372,97.019H63.628l3.488-17.9A3.248,3.248,0,0,1,70.3,76.5h9.391a3.248,3.248,0,0,1,3.188,2.627Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18275",
    "data-name": "Rectangle 18275",
    width: 5.139,
    height: 2.444,
    transform: "translate(76.222 67.461) rotate(90)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18276",
    "data-name": "Rectangle 18276",
    width: 7.666,
    height: 2.444,
    transform: "translate(76.222 91.796) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18277",
    "data-name": "Rectangle 18277",
    width: 3.688,
    height: 2.444,
    transform: "translate(87.616 72.903) rotate(135)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18278",
    "data-name": "Rectangle 18278",
    width: 3.688,
    height: 2.444,
    transform: "translate(64.113 71.163) rotate(45)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35317",
    "data-name": "Group 35317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63293",
    "data-name": "Path 63293",
    d: "M75,85.914a1.779,1.779,0,1,1-1.779,1.779A1.781,1.781,0,0,1,75,85.914m0-3a4.779,4.779,0,1,0,4.779,4.779A4.779,4.779,0,0,0,75,82.914Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35319",
    "data-name": "Group 35319"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7057",
    "data-name": "Ellipse 7057",
    cx: 5.943,
    cy: 5.943,
    r: 5.943,
    transform: "translate(74.648 36.378)",
    fill: "#969bb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35318",
    "data-name": "Group 35318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63294",
    "data-name": "Path 63294",
    d: "M80.233,45.085a.748.748,0,0,1-.5-.187L77.572,43l.99-1.127,1.455,1.277,1.9-3.559,1.322.707-2.347,4.393a.747.747,0,0,1-.527.384A.652.652,0,0,1,80.233,45.085Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7058",
    "data-name": "Ellipse 7058",
    cx: 5.943,
    cy: 5.943,
    r: 5.943,
    transform: "translate(90.32 36.165)",
    fill: "#969bb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35320",
    "data-name": "Group 35320"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18279",
    "data-name": "Rectangle 18279",
    width: 1.5,
    height: 5.402,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 93.828, 40.724)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35321",
    "data-name": "Group 35321"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18280",
    "data-name": "Rectangle 18280",
    width: 5.402,
    height: 1.5,
    transform: "translate(93.822 43.488) rotate(-45)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyReadinessMonitors, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-readiness-monitors.85670cbd.svg";
export { ForwardRef as ReactComponent };